import { render, staticRenderFns } from "./FleetTaskReadOnly.vue?vue&type=template&id=06bf0cc0&"
import script from "./FleetTaskReadOnly.vue?vue&type=script&lang=js&"
export * from "./FleetTaskReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports